import 'dom4'
import 'svgxuse'
import domready from 'domready'
import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
import GlobalHeader from '../global-header'
import MainNav from '../global-header/main-nav'
import PageHero from '../section/page-hero'
import BlogArticleHero from '../section/blog-article-hero'
import BlogArticle from '../section/blog-article'
import RelatedArticles from '../section/related-articles'
import FullWidthText from '../section/full-width-text'
import TextImage from '../section/text-image'
import Accordion from '../accordion'
import HomeHero from '../section/home-hero'
import Locations from '../section/locations'
import BlogArticles from '../section/blog-articles'
import ClassStylesSlider from '../section/class-styles-slider'
import PressBlock from '../section/press-block'
import OnDemand from '../section/on-demand'
// import SubscribeOverlay from '../subscribe-overlay'
import PopupModal from '../popup-modal'
import ContactForm from '../section/contact-form'
import GlobalFooter from '../global-footer'
import TestimonialsSlider from '../section/testimonials'
import ImageGallery from '../section/image-gallery'
import DropDown from '../section/dropdown'
import BannerImageText from '../section/banner-image-text'
import Features from '../section/features'
import FeaturesSlide from '../section/features/slide'
import VideoModule from '../section/video-module'
import VideoWrapper from '../section/video-module/wrapper'
import BuyNow from '../section/buy-now'
import CtaBanner from '../section/cta-banner'
import CardCarousel from '../section/card-carousel'
import RolodexMenu from '../section/rolodex-menu'
import LocationStickyMenu from '../section/location-sticky-menu'

gsap.registerPlugin(DrawSVGPlugin)

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
const globalDuration = 1

domready(() => {
  if (touchDevice) {
    document.body.classList.add('touch')
  }

  history.scrollRestoration = 'manual'

  window.onLoad = function () {
    window.scrollTo(0, 0)
  }

  const doc = document.documentElement
  const globalHeader = document.querySelector('[data-component="global-header"]')
  // const globalHomeHero = document.querySelector('[data-component="home-hero"]')

  const globalHeaderHeight = () => {
    const height = globalHeader.offsetHeight
    doc.style.setProperty('--global-header-height', `${height}px`)
  }
  window.addEventListener('resize', globalHeaderHeight)
  globalHeaderHeight()

  const appHeight = () => {
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  window.addEventListener('resize', appHeight)
  appHeight()

  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element
    })
  })

  document.queryAll('[data-component="main-nav"]').forEach(element => {
    new MainNav({
      element
    })
  })

  document.queryAll('[data-component="full-width-text"]').forEach(element => {
    new FullWidthText({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="text-image"]').forEach(element => {
    new TextImage({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="banner-image-text"]').forEach(element => {
    new BannerImageText({
      element
    })
  })

  document.queryAll('[data-component="accordion"]').forEach(element => {
    new Accordion({
      element
    })
  })

  document.queryAll('[data-component="class-styles-slider"]').forEach(element => {
    new ClassStylesSlider({
      element
    })
  })

  document.queryAll('[data-component="press-block"]').forEach(element => {
    new PressBlock({
      element
    })
  })

  document.queryAll('[data-component="on-demand"]').forEach(element => {
    new OnDemand({
      element
    })
  })

  document.queryAll('[data-component="testimonials-slider"]').forEach(element => {
    new TestimonialsSlider({
      element
    })
  })

  document.queryAll('[data-component="global-footer"]').forEach(element => {
    new GlobalFooter({
      element
    })
  })

  // document.queryAll('[data-component="subscribe-overlay"]').forEach(element => {
  //   new SubscribeOverlay({
  //     element
  //   })
  // })

  document.queryAll('[data-component="popup-modal"]').forEach(element => {
    new PopupModal({
      element
    })
  })

  document.queryAll('[data-component="image-gallery"]').forEach(element => {
    new ImageGallery({
      element
    })
  })

  document.queryAll('[data-component="blog-articles"]').forEach(element => {
    new BlogArticles({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="contact-form"]').forEach(element => {
    new ContactForm({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="blog-article"]').forEach(element => {
    new BlogArticle({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="related-articles"]').forEach(element => {
    new RelatedArticles({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="dropdown"]').forEach(element => {
    new DropDown({
      element
    })
  })

  document.queryAll('[data-component="features"]').forEach(element => {
    new Features({
      element
    })
  })

  document.queryAll('[data-component="features-slider"]').forEach(element => {
    new FeaturesSlide({
      element
    })
  })

  document.queryAll('[data-component="video-module"]').forEach(element => {
    new VideoModule({
      element
    })
  })

  document.queryAll('[data-component="video-wrapper"]').forEach(element => {
    new VideoWrapper({
      element
    })
  })

  document.queryAll('[data-component="buy-now"]').forEach(element => {
    new BuyNow({
      element
    })
  })

})

function init () {
  document.body.classList.remove('page-locked')

  document.queryAll('[data-component="home-hero"]').forEach(element => {
    new HomeHero({
      element
    })
  })

  document.queryAll('[data-component="page-hero"]').forEach(element => {
    new PageHero({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="blog-article-hero"]').forEach(element => {
    new BlogArticleHero({
      element,
      globalDuration
    })
  })

  document.queryAll('main#locations').forEach(element => {
    new Locations({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="cta-banner"]').forEach(element => {
    new CtaBanner({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="card-carousel"]').forEach(element => {
    new CardCarousel({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="rolodex-menu"]').forEach(element => {
    new RolodexMenu({
      element,
      globalDuration
    })
  })

  document.queryAll('[data-component="location-sticky-menu"]').forEach(element => {
    new LocationStickyMenu({
      element,
      globalDuration
    })
  })

  // document.queryAll('[data-component="default-page-hero"]').forEach(element => {
  //   new DefaultPageHero({
  //     element,
  //     globalDuration
  //   })
  // })
}

window.addEventListener('load', e => {
  // const preloader = document.querySelector('[data-component="preloader"')
  // const svg = preloader.querySelector('[data-component="svg"]')
  // const path = svg.querySelector('path')
  const globalHeader = document.querySelector('[data-component="global-header"]')

  const preloaderAnim = gsap.timeline({
    paused: true
    // repeat: -1,
    //onComplete: init
  })

  // preloaderAnim.to(svg, { duration: 0.5, autoAlpha: 1 })
  // preloaderAnim.from(path, { duration: 2.5, drawSVG: '100% 100%', yoyo: true, ease: 'power4.out' })
  // preloaderAnim.to(preloader, { duration: 1, autoAlpha: 0 })
  preloaderAnim.to(globalHeader, { duration: 0.5, autoAlpha: 1 })

  preloaderAnim.play()
  init()

  // preloaderAnim.from(path, {duration: 1, ease: "power4.out"}, "<")

  // const pathFill = gsap.timeline({
  //   paused: true,
  //   onComplete: console.log('fade out preloader')
  // })

  // pathFill.to(path, { duration: 0.5, fill: '#eece38' })
})



// WEBPACK FOOTER //
// ./components/app/index.js